var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":_vm.label,"type":"text","solo-inverted":"","dense":"","prepend-icon":"mdi-account-search"},model:{value:(_vm.string),callback:function ($$v) {_vm.string=$$v},expression:"string"}})}
var staticRenderFns = []

export { render, staticRenderFns }